// extracted by mini-css-extract-plugin
export default {"wrapper":"BullDashboard_wrapper__peS7O","iframe":"BullDashboard_iframe__2rHX+"};